var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-field',{attrs:{"label":"Posto de Atendimento","value":_vm.mutableValue,"searchable":"","multiple":_vm.multiple,"items":_vm.postosAtendimentoSelecionavel,"disabled":_vm.postosAtendimentoSelecionavel.length === 1},on:{"input":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }